.base {
  height: 51px;
  width: 216px;
  border: none;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 500;
  font-family: 'Aeroport';
  color: var(--text-dark);
  background-color: var(--gray-lighter);
  justify-content: flex-start;
}

.base:disabled {
  opacity: .7;
  color: var(--text-dark);
  background-color: var(--gray-lighter);
}

.base:hover:not(:disabled) {
  color: var(--text-dark);
  background-color: var(--gray-light);
}

.dark {
  color: var(--white);
  background-color: var(--background-dark);
}

.dark:disabled {
  opacity: .7;
  color: var(--white);
  background-color: var(--background-dark);
}

.dark:hover:not(:disabled) {
  color: var(--white);
  background-color: var(--background-dark);
  opacity: 0.9;
}

.primary {
  color: var(--white);
  background-color: var(--primary);
}

.primary:disabled {
  opacity: .7;
  color: var(--white);
  background-color: var(--primary);
}

.primary:hover:not(:disabled) {
  color: var(--white);
  background-color: var(--primary-hover);
}

.primaryGradient {
  color: var(--white);
  background: linear-gradient(90deg, var(--primary-gradient1) -18.54%, var(--primary-gradient2) 99.84%);
}

.primaryGradient:disabled {
  opacity: .7;
  color: var(--white);
  background: linear-gradient(90deg, var(--primary-gradient1) -18.54%, var(--primary-gradient2) 99.84%);
}

.primaryGradient:hover:not(:disabled) {
  color: var(--white);
  background: linear-gradient(90deg, var(--primary-gradient1-hover) -18.54%, var(--primary-gradient2-hover) 99.84%);
}

.secondary {
  color: var(--white);
  background-color: var(--secondary);
}

.secondary:disabled {
  opacity: .7;
  color: var(--white);
  background-color: var(--secondary);
}

.secondary:hover:not(:disabled) {
  color: var(--white);
  background-color: var(--secondary-hover);
}

.secondaryGradient {
  color: var(--white);
  background: linear-gradient(90deg, var(--secondary-gradient1) -18.54%, var(--secondary-gradient2) 99.84%);
  opacity: 0.9;
}

.secondaryGradient:disabled {
  opacity: .7;
  color: var(--white);
  background: linear-gradient(90deg, var(--secondary-gradient1) -18.54%, var(--secondary-gradient2) 99.84%);
}

.secondaryGradient:hover:not(:disabled) {
  color: var(--white);
  background: linear-gradient(90deg, var(--secondary-gradient1-hover) -18.54%, var(--secondary-gradient2-hover) 99.84%);
}

.success {
  color: var(--text-light);
  background-color: var(--success);
}

.success:disabled {
  opacity: .7;
  color: var(--text-light);
  background-color: var(--success);
}

.success:hover:not(:disabled) {
  color: var(--text-light);
  background-color: var(--success-hover);
}

.danger {
  color: var(--text-light);
  background-color: var(--danger);
}

.danger:disabled {
  opacity: .7;
  color: var(--text-light);
  background-color: var(--danger);
}

.danger:hover:not(:disabled) {
  color: var(--text-light);
  background-color: var(--danger-hover);
}

.info {
  color: var(--text-light);
  background-color: var(--info);
}

.info:disabled {
  opacity: .7;
  color: var(--text-light);
  background-color: var(--info);
}

.info:hover:not(:disabled) {
  color: var(--text-light);
  background-color: var(--info-hover);
}

.warning {
  color: var(--text-light);
  background-color: var(--warning);
}

.warning:disabled {
  opacity: .7;
  color: var(--text-light);
  background-color: var(--warning);
}

.warning:hover:not(:disabled) {
  color: var(--text-light);
  background-color: var(--warning-hover);
}

.hasDot {
  padding-right: 4rem;
}

.dot {
  position: absolute;
  width: 10px;
  height: 10px;
  right: 1rem;
  border-radius: 5px;
}

.dot.green {
  background-color: var(--green);
}

.dot.white {
  background-color: var(--white);
}
